/* eslint-disable import/prefer-default-export */

import { stringify } from "qs";
import request from "../request";
import { url } from "../service-utils";
import { GetQueryString } from "../utils";

export async function getDataManageList(params) {
  return request(
    `${url.activitySign}/activity/manage/page-list?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}
